/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";

import { formatCurrentTime } from "../../../../../../shared/utils/time";
import { usePlayerTimer } from "../../../../../BasePlayer";

import "./TimeMarker.scss";

export const TimeMarker = () => {
  const {
    timer: { currentTime, duration, isLive, isInfinityStream },
  } = usePlayerTimer();

  if (isLive || isInfinityStream) {
    return <></>;
  }

  const timeMarker = `${formatCurrentTime(currentTime)} / ${formatCurrentTime(
    duration,
  )}`;

  return <div className="TimeMarker">{timeMarker}</div>;
};
